import * as React from "react";
import { ResponsivePicture } from "../../../ReactComponents/responsivePicture/responsivePicture";
import { PictureProfile } from "../../../../ResizedImage/PictureProfile.csharp";
import classNames from "classnames";

interface Picture {
    url: string;
    alt: string;
    responsiveData: {
        focalPoint: { x: number; y: number } | null;
        width: number;
        height: number;
    };
}

interface ImageCarouselItemProps {
    picture: Picture;
    caption: string;
    copyright: string;
    profile: PictureProfile;
}

export const ImageCarouselItem = (props: ImageCarouselItemProps) => {
    return (
        <figure className="ImageCarouselItem">
            <ResponsivePicture
                profile={props.profile}
                model={props.picture}
                imgAttributes={{ "data-object-fit": "contain" }}
            />
            {(props.caption || props.copyright) && (
                <figcaption className="ImageCarouselItem__description">
                    {props.caption && <div className="ImageCarouselItem__caption">{props.caption}</div>}
                    {props.copyright && <div className="ImageCarouselItem__copyright">{props.copyright}</div>}
                </figcaption>
            )}
        </figure>
    );
};
